import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { Replay } from "@sentry/replay";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { createStore } from "redux";
import reducer from "../src/reducer/index";
import { GoogleOAuthProvider } from "@react-oauth/google";
import VersionChecker from "./VersionChecker";

Sentry.init({
  dsn: "https://1b3153121ecc0a6d4b6a037837181069@o4511390458839040.ingest.us.sentry.io/4511390463492096",
  sendDefaultPii: true,
  integrations: [
    new BrowserTracing(),
    new Replay(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^\/backend_api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: process.env.NODE_ENV || "development",
});
const clientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENTID;

const store = createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const checkForNewVersion = async () => {
  const currentVersion = localStorage.getItem("buildVersion");

  try {
    const response = await fetch("/version.json", { cache: "no-store" });
    const { buildVersion } = await response.json();

    if (currentVersion) {
      if (currentVersion !== buildVersion) {
        // console.log(
        //   `New version available: ${buildVersion}. Current version: ${currentVersion}.`
        // );

        localStorage.setItem("buildVersion", buildVersion);
        if ("caches" in window) {
          caches.keys().then((names) => {
            names.forEach((name) => caches.delete(name));
          });
        }
        window.location.reload(true);
      } else {
        // console.log(`App is up-to-date. Current version: ${buildVersion}.`);
      }
    } else {
      // console.log(`Setting initial version: ${buildVersion}`);
      localStorage.setItem("buildVersion", buildVersion);
    }
  } catch (error) {
    // console.error("Error checking app version:", error);
  }
};

// Temporarily disabled to prevent reload loops
// checkForNewVersion();

ReactDOM.render(
  <GoogleOAuthProvider clientId={clientId}>
    <React.StrictMode>
      <Provider store={store}>
        <App />
        <VersionChecker />
      </Provider>
    </React.StrictMode>
  </GoogleOAuthProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
